export interface IPegInstructions {
  PegOffsetValue?: number// 211
  PegPriceType?: number// 1094
  PegMoveType?: number// 835
  PegOffsetType?: number// 836
  PegLimitType?: number// 837
  PegRoundDirection?: number// 838
  PegScope?: number// 840
  PegSecurityIDSource?: string// 1096
  PegSecurityID?: string// 1097
  PegSymbol?: string// 1098
  PegSecurityDesc?: string// 1099
}
